
import { 
  generateElfName as generateName,
  generateFirstName,
  generateLastName
} from './nameGenerator';
import {
  getNamePrefixes,
  getNameSuffixes,
  getLastNames,
  addNamePrefix,
  addNameSuffix,
  addLastName,
  deleteNamePrefix,
  deleteNameSuffix,
  deleteLastName,
  importNamePrefixes,
  importNameSuffixes,
  importLastNames
} from './nameApi';
import { ElfName, ImportResult } from './types';

// Re-export everything from this file to maintain the same public API
export {
  generateFirstName,
  generateLastName,
  getNamePrefixes,
  getNameSuffixes,
  getLastNames,
  addNamePrefix,
  addNameSuffix,
  addLastName,
  deleteNamePrefix,
  deleteNameSuffix,
  deleteLastName,
  importNamePrefixes,
  importNameSuffixes,
  importLastNames
};

// Re-export the main function with the same name as before
export const generateElfName = generateName;
